import { PELAKSANAAN_PRAKTIK_KINERJA_STAGES } from 'app/KinerjaPenilikPegawaiPage/constants/praktikKinerja'

import type {
  StatusPelaksanaanPraktikKinerja,
  PraktikKinerjaFormName,
} from 'types/kinerja-penilik-pegawai'

export const getPelaksanaanPraktikKinerjaPageState = (
  currentState: StatusPelaksanaanPraktikKinerja,
  formName: PraktikKinerjaFormName,
  appealState?: StatusPelaksanaanPraktikKinerja
) => {
  const currentStateStep = Object.values(
    PELAKSANAAN_PRAKTIK_KINERJA_STAGES
  ).findIndex((stage) => stage.includes(currentState))
  const pageStep = Object.keys(PELAKSANAAN_PRAKTIK_KINERJA_STAGES).findIndex(
    (key) => key === formName
  )
  const pageStates = PELAKSANAAN_PRAKTIK_KINERJA_STAGES?.[formName] ?? []

  const isNeedRollbackApproval = () => {
    if (
      ([0, 1].includes(pageStep) &&
        currentStateStep >= 2 &&
        currentState !== 'DISKUSI_TINDAK_LANJUT') ||
      ([3, 4].includes(pageStep) && currentStateStep === 5)
    ) {
      return true
    }

    return false
  }

  const isAppealState = () => {
    if (Boolean(appealState)) {
      const appealStep = Object.keys(
        PELAKSANAAN_PRAKTIK_KINERJA_STAGES
      ).findIndex((key) => key === (appealState ?? '').toLowerCase())
      return pageStep >= appealStep
    }

    return false
  }

  // If the current state is the same as the page state and the current state is not the first state
  if (
    currentStateStep === pageStep &&
    pageStates.findIndex((state) => state === currentState) > 0
  ) {
    return {
      isViewOnly: true,
      isLocked: false,
    }
  }

  // If the current state is greater than the page state
  return {
    isViewOnly: currentStateStep > pageStep,
    isLocked: currentStateStep < pageStep,
    isNeedRollbackApproval: isNeedRollbackApproval(),
    isAppeal: isAppealState(),
  }
}
